export default "__VITE_ASSET__Ct0NE3vU__"